const theme_config = {
  default_theme_mode: "dark",
  logo_file_light: "trainingcamp-logo.webp",
  logo_file_dark: "trainingcamp-logo.webp",
  feature_list: "features_trainingcamp.json",
  theme: "training-camp.json",
  available_modes: ["dark","light"],
  client: {
    id: '10869232-24d7-4a13-a840-289ef581d71b',
    bundleAppName: 'CISSP',
    clientName: 'Training Camp',
    email: 'trainingcamp@yopmail.com',
  }
};

export default theme_config;

